import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DRResponse } from '../../shared/models/response';
import {
    BaseHttpWithBundleService,
    DrQueryParams,
} from '@app/core/services/base/base-service-with-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';


@Injectable({
    providedIn: 'root'
})
export class InsignConfirmService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(httpServiceBundle, true);
    }

    public processInsignConfirm(params: DrQueryParams): Observable<DRResponse<{ link?: string }>> {
        const uri = `${this.uri}/${BackendUriUnits.DISTRIBUTION}/signing/${params.urlSuffix}`;
        return this.http.get<DRResponse<any>>(uri, { params: params.queryParams })
                        .pipe(map(res => res));
    }
}
